var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1041 6.06842C20.4212 6.36977 19.6885 6.57436 18.92 6.6656C19.7051 6.19559 20.3079 5.44911 20.5899 4.56163C19.8544 4.99846 19.0416 5.31364 18.1762 5.48505C17.4823 4.74687 16.4953 4.28516 15.4004 4.28516C13.302 4.28516 11.5989 5.98824 11.5989 8.08668C11.5989 8.38527 11.6321 8.67557 11.6984 8.95204C8.53834 8.79445 5.73765 7.27937 3.86316 4.97911C3.53692 5.54035 3.34891 6.19283 3.34891 6.88954C3.34891 8.20833 4.02075 9.37228 5.04094 10.0524C4.41887 10.0331 3.83274 9.86164 3.3185 9.57687C3.3185 9.59346 3.3185 9.60729 3.3185 9.62388C3.3185 11.4652 4.62899 13.0024 6.36801 13.3507C6.05007 13.4365 5.71277 13.4835 5.36718 13.4835C5.12111 13.4835 4.88335 13.4586 4.65111 13.4143C5.13494 14.9239 6.53943 16.0243 8.20104 16.0547C6.89885 17.0749 5.26212 17.6831 3.47886 17.6831C3.17197 17.6831 2.87061 17.6637 2.57202 17.6306C4.25299 18.7088 6.2519 19.3392 8.4001 19.3392C15.3921 19.3392 19.2158 13.547 19.2158 8.52351C19.2158 8.35762 19.213 8.1945 19.2047 8.03138C19.9484 7.49502 20.5926 6.82596 21.1013 6.06289L21.1041 6.06842Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c50b050d.svg";
export { ForwardRef as ReactComponent };